import React, { useContext, useEffect, useState } from 'react'

import { getBackendData } from '../../api/api'
import { IDevFund } from '../../api/interfaces'
import { ThemeContext } from '../../App'
import { IChart } from '../../components/Chart/interface'
import LoadingChart from '../../components/LoadingIcon/Loading'
import ChartPage from '../../pages/ChartPage/ChartPage'
import { useChartData } from '../../hooks/useChartData'

async function getDevFundBalanceConfig(color: string, inverseColor: string, timeframe: string) {
	const chartData = (await getBackendData('thorchain', 'tc_devfund_earnings', timeframe)) as IDevFund[]
	const series1 = chartData.map((element: IDevFund) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.DEV_FUND_CHANGE }
	})
	const series2 = chartData.map((element: IDevFund) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.DEV_FUND_CHANGE_CUMULATIVE }
	})
	const config: IChart[] = [
		{
			data: series1,
			strokeWidth: 2,
			name: 'change',
			type: 'bars',
			seriesGroup: '[rune]',
			color: 'orange',
			unitSymbol: 'ᚱ'
		},
		{
			data: series2,
			strokeWidth: 2,
			name: 'balance',
			type: 'line',
			seriesGroup: ' [rune]',
			color: 'green',
			unitSymbol: 'ᚱ'
		}
	]
	return { config: config, latestValue: series2[series2.length - 1].y, latestValueDate: series2[series2.length - 1].x }
}

const DevFundBalance = () => {
	const { dataSeries, timeframe, setTimeframe, isLoading, error, retry } = useChartData(getDevFundBalanceConfig, '1d')

	if (error) {
		return (
			<div style={{ padding: 40, textAlign: 'center' }}>
				<p>Error loading chart: {error}</p>
				<button onClick={retry}>Retry</button>
			</div>
		)
	}

	if (isLoading || dataSeries === undefined) {
		return <LoadingChart />
	}
	return (
		<ChartPage
			chartTitle="Development Fund Balance Changes"
			chartDesc="The balance or earnings of the development fund. Monitors resources available for protocol development."
			chartDescTitle="Metric Description"
			chartData={dataSeries.config}
			queryId="1e3872d1-fe6f-489e-b45f-ff3afb699003"
			timeframe={timeframe}
			setTimeframe={setTimeframe}
			hasHours={false}
			hasLogScale={false}
			reverseLegend={true}
		/>
	)
}

export default DevFundBalance
